// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { N300 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PaginationDetailsStyled = styled.div({
	textAlign: 'right',
	margin: `${token('space.075', '6px')} ${8 * 1.25}px`,
	font: `${token('font.body')}`,
	color: token('color.text.subtlest', N300),
	flex: 1,
});
